import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AuthFooter from "../../../../components/Auth/AuthFooter/AuthFooter";
import AuthHeaderBottom from "../../../../components/Auth/AuthHeaderBottom/AuthHeaderBottom";
import AuthHeaderMobile from "../../../../components/Auth/AuthHeaderMobile/AuthHeaderMobile";
import Privileges from "../../../../components/Auth/Privileges/Privileges";
import SubscriptionFail from "../../../../components/Auth/SubscriptionFail/SubscriptionFail";
import { logout } from "../../../../core/actions/app";
import { Constants } from "../../../../core/helpers/constants";
import { history } from "../../../../core/helpers/history";
import { router } from "../../../../core/helpers/router";
import {
  setStorage,
  storageVposResult,
} from "../../../../core/helpers/storage";
import { IStore } from "../../../../core/reducers";
import FirebaseService from "../../../../core/services/firebase.service";
import "./PayByMeFailedPage.scss";

const PayByMeFailedPage = () => {
  const loginMsisdnSubmitData = useSelector(
    (state: IStore) => state.loginMsisdn.submit.data
  );
  const dispatch = useDispatch();
  useEffect(() => {
    setStorage(storageVposResult, Constants.vposResultFailed);
    window.parent.postMessage("payment-failed", "*");
  }, [dispatch]);

  const handleLogout = () => {
    if (loginMsisdnSubmitData) {
      FirebaseService.fireEvent(
        FirebaseService.event_error_count_view_return_login_button_clicked
      );
    } else {
      FirebaseService.fireEvent(
        FirebaseService.event_payment_count_return_login_button_clicked
      );
    }
    logout()(dispatch);
    history.push(router.LOGIN_MSISDN);
  };

  return (
    <div id="pay-by-me-failed-page">
      <div id="pay-by-me-page">
        <div className="container">
          <AuthHeaderBottom />
          <AuthHeaderMobile isBackArrow={false} pageTitle="ABONE OL" />
          <div className="page-content">
            <SubscriptionFail
              // todo revert back to original logic (Mobile Payment) (PLAY-2541)
              isChangePaymentMethodAvailable={false}
              // isChangePaymentMethodAvailable={false}
              errorText="Bir sorun oluştu. Lütfen tekrar dene veya Mobil Ödeme ile devam et"
              // errorText="Bir sorun oluştu. Lütfen tekrar dene"
              textChangePaymentMethod="MOBİL ÖDEME İLE DEVAM ET"
              callbackRetry={() => {
                history.push(router.SUBSCRIPTION);
              }}
              callbackChangePaymentMethod={() => {
                // history.push(router.MOBILE_PAYMENT)
              }}
              callbackLogout={() => handleLogout()}
            />
          </div>
        </div>
        <Privileges />
        <AuthFooter />
      </div>
    </div>
  );
};

export default PayByMeFailedPage;
